import { __awaiter } from "tslib";
import * as React from 'react';
import { Select } from '../../../../../Passenger/components/Field/Select/Select';
import { useSelector } from 'react-redux';
import { getPassengerLabels } from '../../../../../Checkout/store/passengers/selectors';
import { useTranslation } from 'react-i18next';
import { useDownloadOrderDocument } from '../../../../../Checkout/components/Checkout/hooks';
import Button from '../../../../../Button/Button';
import { useTheme } from '../../../../../theme';
import { Field, Form } from 'react-final-form';
import DocumentsList, { NAS_AND_TOURS_SINGLE_OPTION } from './DocumentsList';
import { OrderDocumentType } from '@websky/graphql';
const Download = ({ everyPortPassengerIds, withEveryTravelServices }) => {
    const passengers = useSelector(getPassengerLabels);
    const { t } = useTranslation('FlightInfoCard');
    const theme = useTheme('FlightInfoCard').TicketsModal;
    const { handleDownload, loading } = useDownloadOrderDocument();
    const getPassengersList = React.useMemo(() => {
        const fields = [
            {
                key: 'all',
                value: t('All passengers')
            }
        ];
        Object.keys(passengers).forEach(passengerId => {
            fields.push({
                key: passengerId,
                value: passengers[passengerId]
            });
        });
        return fields;
    }, [passengers]);
    const onSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        yield handleDownload(values['passengers'] !== 'all' ? values['passengers'] : null, values['documents'] !== 'all'
            ? values['documents'] === NAS_AND_TOURS_SINGLE_OPTION
                ? OrderDocumentType.NASTicket
                : values['documents']
            : null);
        if (values['documents'] === NAS_AND_TOURS_SINGLE_OPTION) {
            yield handleDownload(values['passengers'] !== 'all' ? values['passengers'] : null, OrderDocumentType.EveryTravelTicket);
        }
    });
    return (React.createElement(Form, { onSubmit: onSubmit }, ({ handleSubmit }) => (React.createElement("form", { onSubmit: handleSubmit },
        React.createElement("div", { className: theme.downloadContainer },
            React.createElement(Field, { name: "passengers", defaultValue: "all", render: ({ input }) => (React.createElement(Select, { options: getPassengersList, value: input.value, name: 'passengers', label: null, onChange: input.onChange, onBlur: input.onBlur, className: theme.select })) }),
            React.createElement(DocumentsList, { everyPortPassengerIds: everyPortPassengerIds, withEveryTravelServices: withEveryTravelServices }),
            React.createElement("div", { className: theme.buttons },
                React.createElement(Button, { isLoading: loading, className: theme.button, type: "submit", variant: "flat" }, t('Download'))))))));
};
export default Download;
